import React from 'react'
import PropTypes from 'prop-types'
import counter_bg from '../../assets/red-packet/counter_bg.png'
import sub_title from '../../assets/red-packet/sub-title.png'

let { moment } = window

const TIME_FORMAT = 'HH:mm:ss'

let TimeStr = ({ timeStr, text }) => {
  return <div className={'RP__time'}>
    <div className={'RP__time__title'}>{text}</div>
    {/*<div className={'RP__time__text'}>{timeStr[0]}</div>*/}
    {/*<div className={'RP__time__text'}>{timeStr[1]}</div>*/}
    {/*<div className={'RP__time__sub'}>{timeStr[2]}</div>*/}
    {/*<div className={'RP__time__text'}>{timeStr[3]}</div>*/}
    {/*<div className={'RP__time__text'}>{timeStr[4]}</div>*/}
    {/*<div className={'RP__time__sub'}>{timeStr[5]}</div>*/}
    {/*<div className={'RP__time__text'}>{timeStr[6]}</div>*/}
    {/*<div className={'RP__time__text'}>{timeStr[7]}</div>*/}
    <div className={'flex justify-center'}>
      <div className={'relative'}>
        <div className={'absolute z-10 top-0 w-full text-center'}>{timeStr[0]}{timeStr[1]}</div>
        <img className={'w-12'} src={counter_bg} alt=""/>
      </div>
      <div className={'RP__time__sub'}>{timeStr[2]}</div>
      <div className={'relative'}>
        <div className={'absolute z-10 top-0 w-full text-center'}>{timeStr[3]}{timeStr[4]}</div>
        <img className={'w-12'} src={counter_bg} alt=""/>
      </div>
      <div className={'RP__time__sub'}>{timeStr[5]}</div>
      <div className={'relative'}>
        <div className={'absolute z-10 top-0 w-full text-center'}>{timeStr[6]}{timeStr[7]}</div>
        <img className={'w-12'} src={counter_bg} alt=""/>
      </div>
    </div>
  </div>
}

export class Counter extends React.PureComponent {
  static propTypes = {
    started: PropTypes.bool,
    timeStamp: PropTypes.number,
    onCountDown: PropTypes.func
  }
  // 根据这个moment来倒计时
  moment = moment(0, 'x')
  interval = null

  state = {
    // 页面显示的时间字符串
    timeStr: this.moment.utc().format(TIME_FORMAT)
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    // 若timeStamp改变，并且大于0则开始倒计时
    if ((prevProps.timeStamp !== this.props.timeStamp) && this.props.timeStamp > 0) {
      this.setInterval(this.props.timeStamp)
      // } else {
      //   this.clearInterval()
    }
  }

  componentWillUnmount () {
    this.clearInterval()
  }

  clearInterval = () => {
    this.moment = new moment(0, 'x').utc()
    clearInterval(this.interval)
    this.interval = null
  }

  setInterval = timeStamp => {
    this.clearInterval()
    this.moment = new moment(timeStamp, 'x').utc()
    this.setState({ timeStr: this.moment.format(TIME_FORMAT) })
    let interval = () => {
      // moment算微秒时四舍五入
      if (this.moment.format('x') <= 0) {
        this.clearInterval()
        this.props.onCountDown()
      } else {
        this.moment.subtract(1, 'seconds')
        if (this.moment.format('x') < 0) {
          console.log('<', this.moment.format('x'))
          this.moment = new moment(0, 'x').utc()
        }
        // console.log(this.moment.format('x'))
      }
      this.setState({ timeStr: this.moment.format(TIME_FORMAT) })
    }
    this.interval = setInterval(interval, 1000)
  }

  render () {
    let { timeStr } = this.state
    let text = this.props.started ? '红包雨开抢啦！' : <img className={'w-56 m-auto'} src={sub_title} alt=""/>
    return <div className={'text-center'}>
      <TimeStr timeStr={timeStr} text={text}/>
    </div>
  }

  // test
  // pause = () => {
  //   clearInterval(this.interval)
  // }
  //
  // continue = () => {
  //   this.setInterval(this.moment.format('x'))
  //   // this.interval = setInterval(() => {
  //   //   this.moment.subtract(1, 'seconds')
  //   //   this.setState({ timeStr: this.moment.format(TIME_FORMAT) })
  //   // }, 1000)
  // }
  //
  // setTime = () => {
  //   this.setInterval(10000)
  // }
  //
  // test1 = () => {
  //   console.log(this.moment.format('x'))
  // }
}
